import { createFeatureSelector, createSelector } from "@ngrx/store";
import { GetCultureState, SharedState } from "../interfaces/shared.interface";
import { RouterReducerState } from "@ngrx/router-store";

export const sharedSelctor = createFeatureSelector<SharedState>('shared');
export const cultureSelctor = createFeatureSelector<GetCultureState>('culture');
export const selectRouter = createFeatureSelector<RouterReducerState>('routerHistory')





